module.exports = __webpack_public_path__ + "img/bm-2.8c239efa.png";